import {FC, useEffect} from 'react';
import {UserWrapProps} from '../../types';
import {useQuery} from '@apollo/react-hooks';
import {ME} from '../../graphql/queries';
import {setFreshChatUserData} from '../../helpers/trackingEvents';
import {setUserEmail, setUserName, sendUserDataToExtension} from '../../helpers';

const UserWrap: FC<UserWrapProps> = ({withUser, withoutUser, withLoading}) => {
  const {data, loading, refetch} = useQuery(ME);

  // @ts-ignore
  setFreshChatUserData(data && data.User && data.User.get);

  useEffect(() => {
    refetch();
  });

  useEffect(() => {
    if (data && data.User && data.User.get && !data.User.get.error) {
      setUserEmail(data.User.get.email);
      setUserName(data.User.get.firstName);
      return;
    }
    sendUserDataToExtension();
  }, [data && data.User && data.User.get]);

  if (loading && withLoading) {
    return withLoading();
  }

  if (data && data.User && data.User.get && !data.User.get.error) {
    return withUser(data.User.get);
  }

  return withoutUser();
};

export default UserWrap;
